// import type { ItemType, SubMenuType } from 'antd/es/menu/hooks/useItems'
import type { IMenuList } from '@/routes/type'
import { type ItemType, type SubMenuType } from 'antd/es/menu/interface'

export const findMenu = (id: string, menus: ItemType[]) => {
  let result: ItemType | undefined

  menus.forEach((r) => {
    if (r?.key === id) {
      result = r
    } else if ((r as SubMenuType).children) {
      result = findMenu(id, (r as SubMenuType).children)
    }
  })

  return result
}

export const generateMenuItems = (menuList: IMenuList[]) => {
  const result: ItemType[] = []

  menuList.forEach((m) => {
    if (m.menu === false) return
    if (m.parentId) {
      const parentMenu = findMenu(m.parentId, result)
      if (!Array.isArray((parentMenu as SubMenuType).children)) {
        ;(parentMenu as SubMenuType).children = []
      }
      ;(parentMenu as SubMenuType).children.push({
        key: m.id,
        icon: m.icon,
        label: m.name
      })
    } else {
      result.push({
        key: m.id,
        icon: m.icon,
        label: m.name
      })
    }
  })

  return result
}
